export default function ViewField({ value, label }) {
  return value ?? label;
}
